import urljoin from "url-join";
import axios from "axios";
import { isOfflineMode } from "./offlineMode";

axios.defaults.withCredentials = true;

export const getApiUrl = (...path: string[]) => {
  if (isOfflineMode()) {
    throw new Error("API calls are disabled in offline mode");
  }
  return urljoin(String(import.meta.env.VITE_API_PREFIX || "/api"), ...path);
};

export const SOCKET_DOMAIN = isOfflineMode()
  ? ""
  : String(import.meta.env.VITE_SOCKET_DOMAIN || "");
export const SOCKET_PATH = isOfflineMode()
  ? ""
  : String(import.meta.env.VITE_SOCKET_PATH || "/socket.io");
